var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "navbar is-primary-mobile has-shadow" }, [
    _c("div", { staticClass: "navbar-brand" }, [
      _c(
        "a",
        {
          staticClass: "navbar-burger burger",
          attrs: {
            role: "button",
            "aria-label": "menu",
            "aria-expanded": "false",
            "data-target": "navbar-menu"
          },
          on: { click: _vm.toggleNavbarMenu }
        },
        [
          _c("span", { attrs: { "aria-hidden": "true" } }),
          _c("span", { attrs: { "aria-hidden": "true" } }),
          _c("span", { attrs: { "aria-hidden": "true" } })
        ]
      )
    ]),
    _c(
      "div",
      {
        staticClass: "navbar-menu",
        class: _vm.navbarMenuIsActive,
        attrs: { id: "navbar-menu" }
      },
      [
        _c("AppMenu", { staticClass: "navbar-start" }),
        _c("div", { staticClass: "navbar-end" }, [
          _c(
            "a",
            {
              staticClass:
                "navbar-item is-flex is-centered link-navbar-sign-manifest",
              attrs: {
                href: "https://www.cfdi.com.mx/manifiesto",
                target: "__blank"
              }
            },
            [_vm._v("\n        Firmar manifiesto CONTPAQi\n      ")]
          ),
          _c(
            "div",
            {
              staticClass: "navbar-item has-dropdown is-hoverable",
              class: { "is-active": _vm.activeMenus.includes("cfdis") }
            },
            [
              _c(
                "a",
                { staticClass: "navbar-link is-arrowless link-navbar-cfdis" },
                [
                  _c("BIcon", { attrs: { icon: "bank", type: "is-primary" } }),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v("CFDIs")
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "navbar-dropdown" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-new-invoice",
                      attrs: { to: { name: "NewInvoice" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "bank", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Factura")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-new-auto-invoice",
                      attrs: { to: { name: "NewAutoInvoice" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "auto-fix", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Autofactura")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-new-rep",
                      attrs: { to: { name: "NewRep" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: {
                          icon: "file-document-box-outline",
                          type: "is-primary"
                        }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Complemento de Pago")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-new-credit-note",
                      attrs: { to: { name: "NewCreditNote" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "credit-card-plus", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Nota de Crédito")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-new-sale-note",
                      attrs: { to: { name: "NewSaleNote" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: {
                          icon: "file-document-box-outline",
                          type: "is-primary"
                        }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Nota de Remisión")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "navbar-item has-dropdown is-hoverable",
              class: { "is-active": _vm.activeMenus.includes("new") }
            },
            [
              _c(
                "a",
                {
                  staticClass: "navbar-link is-arrowless link-navbar-catalogs"
                },
                [
                  _c("BIcon", { attrs: { icon: "plus", type: "is-primary" } }),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v("Agregar")
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "navbar-dropdown" },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-add-customer",
                      on: { click: _vm.openModalCustomer }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "account-group", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("\n              Cliente\n            ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-add-product",
                      attrs: { to: { name: "SkuCatalog" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "barcode", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Producto")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "navbar-item is-flex has-text-white link-navbar-add-employee",
                      attrs: { to: { name: "EmployeePush" } }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "briefcase-outline", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v(" Empleado")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "navbar-item has-dropdown is-hoverable",
              class: { "is-active": _vm.activeMenus.includes("settings") }
            },
            [
              _c(
                "a",
                { staticClass: "navbar-link is-arrowless" },
                [
                  _c("BIcon", {
                    attrs: { icon: "settings", type: "is-primary" }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "navbar-dropdown" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "navbar-item is-flex",
                      attrs: {
                        to: { name: "Company", params: { id: _vm.company } }
                      }
                    },
                    [
                      _c("BIcon", {
                        attrs: { icon: "domain", type: "is-primary" }
                      }),
                      _c("span", { staticClass: "has-text-primary" }, [
                        _vm._v("Empresa")
                      ])
                    ],
                    1
                  ),
                  _vm.canAddRFC
                    ? _c(
                        "RouterLink",
                        {
                          staticClass: "navbar-item is-flex",
                          attrs: { to: { name: "AddRFC" } }
                        },
                        [
                          _c("BIcon", {
                            attrs: { icon: "fingerprint", type: "is-primary" }
                          }),
                          _c("span", { staticClass: "has-text-primary" }, [
                            _vm._v("Agregar RFC")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.companies.length > 1
                    ? _vm._l(
                        _vm.companies.filter(function(c) {
                          return c.id !== _vm.company
                        }),
                        function(company) {
                          return _c(
                            "a",
                            {
                              key: company.id,
                              staticClass: "navbar-item is-flex",
                              on: {
                                click: function($event) {
                                  return _vm.changeCompany(company)
                                }
                              }
                            },
                            [
                              _c("BIcon", {
                                attrs: {
                                  icon: "fingerprint",
                                  type: "is-primary"
                                }
                              }),
                              _c("span", { staticClass: "has-text-primary" }, [
                                _vm._v(_vm._s(company.rfc.rfc))
                              ])
                            ],
                            1
                          )
                        }
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "RouterLink",
                        {
                          staticClass: "navbar-item is-flex",
                          attrs: {
                            to: { name: "AddCIEC", params: { id: _vm.company } }
                          }
                        },
                        [
                          _c("BIcon", {
                            attrs: { icon: "archive", type: "is-primary" }
                          }),
                          _c("span", { staticClass: "has-text-primary" }, [
                            _vm._v("CIEC")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm.companies.length > 1
            ? _c(
                "span",
                { staticClass: "navbar-item is-centered has-text-primary" },
                [
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v(_vm._s(_vm.$store.state.company.rfc))
                  ])
                ]
              )
            : _vm._e(),
          _c(
            "span",
            { staticClass: "navbar-item is-flex is-centered" },
            [
              _c(
                "BTooltip",
                {
                  attrs: {
                    label: "Base de conocimientos",
                    position: "is-bottom",
                    type: "is-primary"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "is-flex is-centered",
                      attrs: { href: _vm.knowledgeBaseLink, target: "__blank" }
                    },
                    [
                      _c("BIcon", {
                        attrs: {
                          icon: "help-circle-outline",
                          type: "is-primary"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            { staticClass: "navbar-item is-flex is-centered" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button is-danger is-outlined link-sign-out",
                  attrs: {
                    "active-class": "is-active",
                    to: { name: "SignOut" }
                  }
                },
                [_c("BIcon", { attrs: { icon: "exit-to-app" } })],
                1
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }